// Controls showing/hiding checkout buttons and dynamic payment options
// based on cart total and MINIMUM_ORDER_AMOUNT_CENTS from constants.js

function setButtonRestricted(element, restricted) {
  if (!element) return;
  element.disabled = restricted;
  if (restricted) {
    element.classList.add('restrict-checkout');
  } else {
    element.classList.remove('restrict-checkout');
  }
}

function setContainerRestricted(element, restricted) {
  if (!element) return;
  if (restricted) {
    element.classList.add('restrict-checkout');
    element.style.display = 'none';
  } else {
    element.classList.remove('restrict-checkout');
    element.style.display = '';
  }
}

function toggleRestrictions(cartTotalCents) {
  const restricted = cartTotalCents < (typeof MINIMUM_ORDER_AMOUNT_CENTS !== 'undefined' ? MINIMUM_ORDER_AMOUNT_CENTS : 5000);

  // Cart page & drawer checkout buttons
  const checkoutButton = document.getElementById('checkout');
  const drawerCheckout = document.getElementById('CartDrawer-Checkout');
  const cartCheckoutButtons = document.querySelectorAll('.cart__checkout-button');
  const notificationCheckouts = document.querySelectorAll('button[name="checkout"]');

  setButtonRestricted(checkoutButton, restricted);
  setButtonRestricted(drawerCheckout, restricted);
  cartCheckoutButtons.forEach((el) => setButtonRestricted(el, restricted));
  notificationCheckouts.forEach((el) => setButtonRestricted(el, restricted));

  // Additional payment methods containers (cart, product pages, drawer)
  // Use more specific selectors and ensure we can show them when unrestricted
  const paymentContainers = document.querySelectorAll(
    '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .product__dynamic-checkout-buttons, .shopify-payment-button'
  );
  paymentContainers.forEach((el) => setContainerRestricted(el, restricted));

  // Show/hide inline restrict messages on cart/product pages
  const restrictMessages = document.querySelectorAll('.restrict-checkout-container');
  restrictMessages.forEach((el) => {
    if (restricted) {
      el.classList.add('active');
      el.style.display = '';
    } else {
      el.classList.remove('active');
      el.style.display = 'none';
    }
  });

  // For cart drawer, toggle drawer-specific message
  const drawerMessage = document.getElementById('CartDrawer-Restrict');
  if (drawerMessage) {
    if (restricted) {
      drawerMessage.style.display = '';
    } else {
      drawerMessage.style.display = 'none';
    }
  }
}

// Initialize: fetch current cart and set initial state
function initCartThreshold() {
  // Use /cart.js to get current cart state
  fetch('/cart.js', { credentials: 'same-origin' })
    .then((r) => r.json())
    .then((cart) => {
      toggleRestrictions(cart.total_price || 0);
    })
    .catch(() => {
      // If fetch fails, fall back to no restriction
      toggleRestrictions(0);
    });

  // Subscribe to pubsub cart updates if available
  // Use debounced function to avoid multiple rapid updates
  const debouncedUpdate = (function() {
    let timeoutId;
    return function() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((cart) => {
            toggleRestrictions(cart.total_price || 0);
            
            // Also fetch and update the footer section so checkout button gets re-rendered with correct disabled state
            const footerElement = document.getElementById('main-cart-footer');
            if (footerElement && footerElement.dataset.id) {
              const sectionId = footerElement.dataset.id;
              fetch(`/?sections=${sectionId}`)
                .then((r) => r.json())
                .then((data) => {
                  if (data && data[sectionId]) {
                    const newHtml = data[sectionId];
                    // Create a temp container and parse the HTML
                    const temp = document.createElement('div');
                    temp.innerHTML = newHtml;
                    const newFooter = temp.querySelector('#main-cart-footer') || temp.firstElementChild;
                    if (newFooter) {
                      footerElement.replaceWith(newFooter);
                      // Re-run restriction toggle on the newly inserted footer
                      toggleRestrictions(cart.total_price || 0);
                    }
                  }
                })
                .catch(() => {
                  // If footer fetch fails, still toggle restrictions on current DOM
                  toggleRestrictions(cart.total_price || 0);
                });
            }
          })
          .catch(() => {
            // fallback
          });
      }, 200);
    };
  })();

  if (typeof subscribe === 'function') {
    subscribe('cart-update', debouncedUpdate);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartThreshold);
} else {
  initCartThreshold();
}
